export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "name": "Тренинг по лидерству для руководителей",
        "description": "Тренинг по лидерству для руководителей и управленческих команд: влияние, коммуникация, мотивация, принятие решений и развитие команды. Корпоративное обучение в Минске и онлайн.",
        "url": "https://business-training.by/menedzhment-i-liderstvo/trening-po-liderstvu",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Business Training",
          "url": "https://business-training.by"
        }
      },
      {
        "@type": "Service",
        "name": "Тренинг по лидерству для руководителей",
        "description": "Корпоративный тренинг по лидерству для руководителей и управленческих команд. Развитие лидерских навыков: влияние, коммуникация, мотивация, принятие решений, развитие команды, делегирование, обратная связь, управление конфликтами и изменениями.",
        "provider": {
          "@type": "Person",
          "name": "Алексей Сивко",
          "jobTitle": "Бизнес-тренер, консультант по продажам и управлению, фасилитатор, сертифицированный коуч ICU",
          "url": "https://business-training.by/o-trenere",
          "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
        },
        "areaServed": [
          { "@type": "Country", "name": "Беларусь" },
          { "@type": "Country", "name": "Россия" },
          { "@type": "Country", "name": "Казахстан" },
          { "@type": "Country", "name": "Израиль" }
        ],
        "serviceType": "тренинг по лидерству, обучение лидерству, развитие лидерских навыков",
        "url": "https://business-training.by/menedzhment-i-liderstvo/trening-po-liderstvu"
      },
      {
        "@type": "Person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер",
        "description": "18+ лет практики в корпоративном обучении. 100+ корпоративных проектов, 450+ тренингов и бизнес-сессий, 4500+ участников. Средняя оценка участников — 9,09/10. Работал с компаниями Беларуси, России, Казахстана и Израиля.",
        "url": "https://business-training.by/o-trenere",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Что такое тренинг по лидерству?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Тренинг по лидерству — это практическая программа, направленная на развитие лидерских навыков руководителя: умения влиять на команду, формировать доверие, мотивировать сотрудников, принимать решения и вести команду через сложные ситуации. В отличие от общего управленческого тренинга, здесь фокус сделан именно на лидерском поведении и управленческом влиянии, а не на всём спектре управленческих компетенций."
            }
          },
          {
            "@type": "Question",
            "name": "Для кого подходит обучение лидерству?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Обучение подходит для руководителей всех уровней: новых руководителей, которым необходимо сформировать лидерскую позицию; опытных руководителей, желающих усилить влияние на команду; РОПов и коммерческих руководителей; топ-менеджеров; кадрового резерва, готовящегося к управленческим должностям; управленческих команд, которым важно сформировать общее понимание лидерства."
            }
          },
          {
            "@type": "Question",
            "name": "Чем лидер отличается от руководителя?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Руководитель обладает формальными полномочиями и должностью — он имеет право ставить задачи и требовать их выполнения. Лидер, помимо формальной власти, обладает управленческим влиянием: сотрудники следуют за ним не только из-за должности, а потому что доверяют, понимают цели и разделяют ответственность за результат. Практическое лидерство — это не врождённое качество, а набор конкретных поведенческих навыков, которые можно развивать."
            }
          },
          {
            "@type": "Question",
            "name": "Какие лидерские навыки развиваются на тренинге?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "На тренинге развиваются: управленческое влияние, коммуникация, постановка целей, мотивация команды, делегирование, обратная связь, принятие решений, проведение сложных разговоров, развитие сотрудников, эмоциональный интеллект, управление конфликтами и управление изменениями. Все навыки отрабатываются на реальных управленческих ситуациях."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли обучить лидерству нового руководителя?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, и это особенно важно. Когда сильного специалиста повышают до руководителя, ему необходимы новые компетенции: теперь он отвечает не за свой личный результат, а за результат команды. Тренинг помогает новому руководителю освоить лидерские инструменты с первых дней в управленческой роли и избежать типичных ошибок начинающих руководителей."
            }
          },
          {
            "@type": "Question",
            "name": "Подходит ли тренинг для опытных руководителей?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, опытные руководители часто получают на тренинге систематизацию своих подходов, новые инструменты влияния и возможность увидеть свои управленческие привычки со стороны. Программа адаптируется под уровень участников: для опытных руководителей мы разбираем более сложные управленческие ситуации и работаем с тонкими аспектами лидерского поведения."
            }
          },
          {
            "@type": "Question",
            "name": "Как развить управленческое влияние?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Управленческое влияние развивается через практику конкретных поведенческих навыков: формирование доверия через последовательность действий, понятную постановку целей, качественную обратную связь, развитие самостоятельности сотрудников, умение принимать решения и брать ответственность, конструктивное прохождение через конфликты. На тренинге мы разбираем и отрабатываем каждый из этих элементов."
            }
          },
          {
            "@type": "Question",
            "name": "Как научиться мотивировать команду?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Мотивация команды начинается с понимания того, что деньги — не единственный и часто не главный фактор. Руководитель влияет на вовлечённость через ясность целей, признание результатов, обратную связь, рабочую среду, уровень ответственности и самостоятельности сотрудников. На тренинге мы разбираем, как понять индивидуальную мотивацию каждого сотрудника и создать условия для высокой вовлечённости."
            }
          },
          {
            "@type": "Question",
            "name": "Как лидерство связано с делегированием?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Лидерство и делегирование связаны напрямую. Лидер не выполняет работу за сотрудников — он создаёт систему, в которой сотрудники самостоятельно достигают результата. Делегирование — это передача ответственности вместе с полномочиями. На тренинге мы разбираем, как делегировать без потери контроля, как развивать самостоятельность команды и как выходить из ловушки «главного исполнителя»."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли адаптировать программу под компанию?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, адаптация — обязательный этап. Мы не начинаем с шаблонной презентации. Сначала разбираемся в задачах компании, уровне участников, отраслевой специфике и реальных управленческих ситуациях. После этого содержание программы настраивается так, чтобы участники работали с актуальными для них задачами и кейсами."
            }
          },
          {
            "@type": "Question",
            "name": "Сколько длится тренинг по лидерству?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Продолжительность зависит от задач компании и уровня участников. Корпоративный тренинг обычно длится 1-3 дня интенсивной работы. Модульная программа может занимать несколько недель или месяцев с практикой между модулями. Точный формат и продолжительность определяются после диагностики потребностей компании."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли проводить обучение онлайн?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, онлайн-формат доступен и эффективен для распределённых команд. Он удобен для модульных программ с практическими заданиями между встречами. Для отработки навыков офлайн-формат даёт более высокую вовлечённость, поэтому оптимальным часто является смешанный формат: очные интенсивные сессии с онлайн-сопровождением."
            }
          },
          {
            "@type": "Question",
            "name": "Что происходит после тренинга?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "После тренинга при необходимости продолжается сопровождение: разбор реальных управленческих ситуаций, поддержка внедрения инструментов, ответы на вопросы участников. Компания также может получить алгоритмы, чек-листы и другие материалы для дальнейшего использования. Сопровождение повышает вероятность того, что новые лидерские навыки закрепятся в практике."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли организовать сопровождение руководителей?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, сопровождение — отдельный элемент программы, который можно включить после тренинга. Это могут быть регулярные онлайн-встречи для разбора ситуаций, индивидуальные коуч-сессии с руководителями, поддержка в чате или очные встречи для работы с конкретными управленческими задачами. Формат сопровождения подбирается под потребности компании."
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}